module.exports = __webpack_public_path__ + "img/menos.aaf6e078.svg";